
export const INPUT_CHANGE = "[LOGIN] INPUT CHANGE";
export const INPUT_ERROR = "[LOGIN] INPUT_ERROR";

export const LOGIN_REQUEST = "[LOGIN] LOGIN REQUEST";
export const LOGIN_SUCCESS = "[LOGIN] LOGIN SUCCESS";
export const LOGIN_ERROR = "[LOGIN] LOGIN ERROR";

export const LOGOUT_REQUEST = "[LOGIN] LOGOUT REQUEST";
export const LOGOUT_SUCCESS = "[LOGIN] LOGOUT SUCCESS";


// WEBPACK FOOTER //
// ./src/modules/login/login-action-types.js